import { useState } from 'react'
import { Alert } from '@jmvilaca-corp/auth-ui'
import { useCalendarSources, useConnectorStatus } from '../lib/connectors'
import ConnectorSignInDialog from './ConnectorSignInDialog'

/**
 * Dit, au-dessus du calendrier, pourquoi l'application ne parvient pas a se
 * connecter a l'application liee, et propose d'y remedier. Tant que tout va
 * bien il ne montre rien : l'icone du calendrier suffit.
 */
export default function ConnectorBanner({ connector }: { connector: string }) {
  const sources = useCalendarSources()
  const status = useConnectorStatus(connector)
  const [signingIn, setSigningIn] = useState(false)

  const label = sources.data?.find((source) => source.key === connector)?.label ?? connector

  if (status.isPending) {
    return null
  }

  if (status.isError) {
    return <Alert tone="info">La connexion a {label} n'a pas pu etre verifiee : {status.error.message}</Alert>
  }

  const { state, login } = status.data

  if (state === 'connected') {
    return null
  }

  if (state === 'unavailable') {
    return (
      <Alert tone="info">
        {label} ne repond pas pour l'instant : ses calendriers restent tels qu'a leur derniere mise a jour.
      </Alert>
    )
  }

  return (
    <>
      <Alert>
        {state === 'rejected'
          ? `${label} refuse les identifiants enregistres.`
          : `Aucun compte ${label} n'est lie a ce calendrier.`}{' '}
        <button type="button" className="font-medium underline underline-offset-4" onClick={() => setSigningIn(true)}>
          {state === 'rejected' ? 'Mettre a jour les identifiants' : 'Lier mon compte'}
        </button>
      </Alert>
      {signingIn && (
        <ConnectorSignInDialog
          source={{ key: connector, label, login }}
          onLinked={() => setSigningIn(false)}
          onClose={() => setSigningIn(false)}
        />
      )}
    </>
  )
}
